import type { Period } from "../lib/hooks";

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/**
 * Independent month + year dropdowns. Selecting a month defaults to the current
 * year; selecting only a year shows that whole year. `value` of {} means all
 * time. Years span enough history for long-running personal records.
 */
export function PeriodFilter({
  value,
  onChange,
}: {
  value: Period;
  onChange: (p: Period) => void;
}): JSX.Element {
  const now = new Date();
  const currentYear = now.getUTCFullYear();
  const years = Array.from({ length: 14 }, (_, i) => currentYear + 1 - i);

  return (
    <div className="grid min-w-0 grid-cols-2 gap-2" aria-label="Period filter">
      <select
        aria-label="Month"
        className="min-w-0 rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
        value={value.month ? String(value.month) : ""}
        onChange={(e) =>
          onChange(
            e.target.value
              ? { month: Number(e.target.value), year: value.year ?? currentYear }
              : value.year
                ? { year: value.year }
                : {},
          )
        }
      >
        <option value="">All months</option>
        {MONTHS.map((m, i) => (
          <option key={m} value={i + 1}>
            {m}
          </option>
        ))}
      </select>
      <select
        aria-label="Year"
        className="min-w-0 rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20"
        value={value.year ? String(value.year) : ""}
        onChange={(e) =>
          onChange(
            e.target.value
              ? { ...(value.month ? { month: value.month } : {}), year: Number(e.target.value) }
              : {},
          )
        }
      >
        <option value="">All years</option>
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  );
}
